(function () {
  function setOpen(item, open) {
    var btn = item.querySelector("[data-efq-trigger]");
    var panel = item.querySelector("[data-efq-panel]");
    item.classList.toggle("is-open", open);
    if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
    if (panel) {
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
    }
  }

  function initFaq(root) {
    if (!root || root.dataset.efqInit === "true") return;
    root.dataset.efqInit = "true";

    var items = Array.prototype.slice.call(root.querySelectorAll("[data-efq-item]"));
    if (!items.length) return;

    items.forEach(function (item, index) {
      var btn = item.querySelector("[data-efq-trigger]");
      if (!btn) return;

      // First item open by default (Wonderbly-style)
      setOpen(item, index === 0 || item.classList.contains("is-open"));

      btn.addEventListener("click", function () {
        var willOpen = !item.classList.contains("is-open");
        items.forEach(function (other) {
          setOpen(other, other === item ? willOpen : false);
        });
      });
    });

    window.addEventListener("resize", function () {
      items.forEach(function (item) {
        if (!item.classList.contains("is-open")) return;
        var panel = item.querySelector("[data-efq-panel]");
        if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-elfink-faq]").forEach(initFaq);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector("[data-elfink-faq]")
      : null;
    if (root) {
      root.dataset.efqInit = "false";
      initFaq(root);
    }
  });
})();
